import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

function App() {
  const [isWalletAvailable, setIsWalletAvailable] = useState(null);

  useEffect(() => {
    const walletHash = localStorage.getItem('wallet_hash');
    const walletAddress = localStorage.getItem('wallet_address');
    if (walletHash && walletAddress) {
      setIsWalletAvailable(true); // Cüzdan varsa giriş yapmaya yönlendir
    } else {
      setIsWalletAvailable(false); // Cüzdan yoksa Welcome sayfasına yönlendir
    }
  }, []);

  // Yükleme sırasında, isWalletAvailable değeri null ise loading gösterebiliriz.
  if (isWalletAvailable === null) {
    return <div>Yükleniyor...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={isWalletAvailable ? <Navigate to="/login" /> : <Welcome />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={isWalletAvailable ? <Dashboard /> : <Navigate to="/login" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
